import React, { lazy, Suspense } from "react";
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import RestaurantMenuLanding from './pages/restaurant-menu-landing';
import RestaurantAdminDashboard from './pages/restaurant-admin-dashboard';
import ModalitesPolitiques from './pages/modalites-politiques';

const QRCodeGenerator = lazy(() => import('./pages/qr-code-generator'));
const ARViewer = lazy(() => import('./pages/ar-viewer'));
const ManagementContentEditor = lazy(() => import('./pages/management-content-editor'));

const RouteFallback = () => (
  <div className="min-h-screen flex items-center justify-center bg-background">
    <p className="text-muted-foreground font-caption">Chargement…</p>
  </div>
);

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = sessionStorage.getItem('adminAuthenticated') === 'true';
  return isAuthenticated ? children : <Navigate to="/restaurant-admin-dashboard" replace />;
};

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<RestaurantMenuLanding />} />
        <Route
          path="/qr-code-generator"
          element={
            <ProtectedRoute>
              <Suspense fallback={<RouteFallback />}>
                <QRCodeGenerator />
              </Suspense>
            </ProtectedRoute>
          }
        />
        <Route path="/restaurant-menu-landing" element={<RestaurantMenuLanding />} />
        <Route
          path="/ar-viewer"
          element={
            <Suspense fallback={<RouteFallback />}>
              <ARViewer />
            </Suspense>
          }
        />
        <Route path="/restaurant-admin-dashboard" element={<RestaurantAdminDashboard />} />
        <Route
          path="/management-content-editor"
          element={
            <ProtectedRoute>
              <Suspense fallback={<RouteFallback />}>
                <ManagementContentEditor />
              </Suspense>
            </ProtectedRoute>
          }
        />
        <Route path="/modalites-politiques" element={<ModalitesPolitiques />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};
export default Routes;
